// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"34c457f3","693":"9a83c11b"}[chunkId] + ".chunk.css";
};